import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-014c12e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "omny-ui-layout"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  class: "pagination-area"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_the_topbar = _resolveComponent("the-topbar");
  const _component_omny_modal_header = _resolveComponent("omny-modal-header");
  const _component_b_modal = _resolveComponent("b-modal");
  const _component_RightStripIcon = _resolveComponent("RightStripIcon");
  const _component_FlexColumn = _resolveComponent("FlexColumn");
  const _component_feature = _resolveComponent("feature");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "top-content-wrapper",
    style: _normalizeStyle($props.showPagination ? {
      ['--pagination-height']: '61px'
    } : {})
  }, [_createElementVNode("div", null, [_renderSlot(_ctx.$slots, "topbar", {}, undefined, true)]), !_ctx.$slots['topbar'] ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_the_topbar, null, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "topbar-contents", {}, undefined, true)]),
    _: 3
  })])) : _createCommentVNode("", true), _createElementVNode("div", null, [_renderSlot(_ctx.$slots, "topbar-sub", {}, undefined, true)]), _createElementVNode("div", {
    class: "content",
    style: _normalizeStyle({
      padding: $props.contentPadding
    })
  }, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)], 4), $props.showPagination ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "pagination", {}, undefined, true)])) : _createCommentVNode("", true)], 4), _createVNode(_component_feature, {
    name: $props.rightStripFeatureName
  }, {
    default: _withCtx(() => [_ctx.$slots['right-strip-modal'] ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "right-strip",
      style: _normalizeStyle({
        padding: $props.rightStripPadding
      })
    }, [_createVNode(_component_b_modal, {
      class: "modal-fullscreen right-strip-modal",
      modelValue: $options.modal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.modal = $event),
      noFade: "",
      onShown: _cache[2] || (_cache[2] = $event => _ctx.$emit('modal-shown'))
    }, _createSlots({
      header: _withCtx(() => [_createVNode(_component_omny_modal_header, {
        modelValue: $options.modal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.modal = $event),
        icon: "settings-new-ui"
      }, {
        title: _withCtx(() => [_createTextVNode("Settings")]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "settings-header-right", {}, undefined, true)]),
        _: 3
      }, 8, ["modelValue"])]),
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "right-strip-modal", {}, undefined, true)]),
      _: 2
    }, [$props.hideSettingsFooterButtons ? {
      name: "footer",
      fn: _withCtx(() => [_hoisted_4]),
      key: "0"
    } : undefined]), 1032, ["modelValue"]), _createVNode(_component_FlexColumn, null, {
      default: _withCtx(() => [_createVNode(_component_RightStripIcon, {
        disabled: !$props.activateSettings,
        icon: "settings-new-ui",
        info: $props.settingsInfo,
        onClick: _cache[3] || (_cache[3] = () => {
          if ($props.activateSettings) {
            $options.modal = true;
          }
        })
      }, null, 8, ["disabled", "info"])]),
      _: 1
    })], 4)) : _createCommentVNode("", true)]),
    _: 3
  }, 8, ["name"]), _ctx.$slots['right-strip-modal-file-upload'] ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "right-strip",
    style: _normalizeStyle({
      padding: $props.rightStripPadding
    })
  }, [_createVNode(_component_b_modal, {
    class: "modal-fullscreen right-strip-modal-file-upload",
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $options.modal = $event),
    noFade: "",
    onShown: _cache[6] || (_cache[6] = $event => _ctx.$emit('modal-shown')),
    "no-close-on-backdrop": ""
  }, {
    header: _withCtx(() => [_createVNode(_component_omny_modal_header, {
      modelValue: $options.modal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $options.modal = $event),
      icon: "upload-csv",
      color: "#312783"
    }, {
      title: _withCtx(() => [_createTextVNode("Import Data")]),
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "settings-header-right-file-upload", {}, undefined, true)]),
      _: 3
    }, 8, ["modelValue"])]),
    footer: _withCtx(() => [_createVNode(_component_app_button, {
      version: "small",
      v2: "",
      onClick: $options.onCloseFileUpload
    }, {
      default: _withCtx(() => [_createTextVNode("Close")]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "right-strip-modal-file-upload", {}, undefined, true)]),
    _: 3
  }, 8, ["modelValue"]), _createVNode(_component_FlexColumn, null, {
    default: _withCtx(() => [_createVNode(_component_RightStripIcon, {
      disabled: !$props.activateSettings,
      icon: "upload-csv",
      info: $props.settingsInfoUpload,
      onClick: _cache[7] || (_cache[7] = () => {
        if ($props.activateSettings) {
          $options.modal = true;
        }
      })
    }, null, 8, ["disabled", "info"]), _createVNode(_component_RightStripIcon, {
      disabled: !$props.activateSettings,
      icon: "download-csv",
      info: $props.settingsInfoDownload,
      onClick: $options.handleDownloadCSVClick
    }, null, 8, ["disabled", "info", "onClick"])]),
    _: 1
  })], 4)) : _createCommentVNode("", true)]);
}